export enum MethodsMfa {
    iPhone = 'iPhone',
    android = 'android',
    yubikey = 'yubikey',
    u2f = 'u2f'
}

export enum ManageMfaSteps {
    chooseMethod = 0,
    setUpDevice = 1,
    complete = 2
}
